<template>
  <div class="imgsort-list">
    <div class="page-filter">
      <div class="condition-wrap">
        <span class="condition-label">订单号</span>
        <el-input class="w200" maxlength="30" style="width:200px;" v-model="orderNo" placeholder="请输入订单号"></el-input>
      </div>
      <div v-if="!isBrand" class="condition-wrap">
        <span class="condition-label">订单手机号</span>
        <el-input class="w200" maxlength="20" style="width:200px;" v-model="phoneNumber" placeholder="请输入标签"></el-input>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">支付方式</span>
        <el-select v-model="payType">
          <div v-for="item in payTypeList" :key="item.value">
            <el-option :label="item.name" :value="item.value"></el-option>
          </div>
        </el-select>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">状态</span>
        <el-select v-model="status">
          <div v-for="item in statusList" :key="item.value">
            <el-option :label="item.name" :value="item.value"></el-option>
          </div>
        </el-select>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">订单时间</span>
        <el-date-picker v-model="date" type="daterange" range-separator="至" clearable start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
      </div>
      <div class="condition-wrap">
        <el-button type="primary" @click="getList">筛选</el-button>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" size="middle" border stripe>
      <!-- <el-table-column prop="id" label="序号" align="center" width="100"> </el-table-column> -->
      <el-table-column prop="designKeyUrl" label="IP图案" align="center">
        <template slot-scope="scope">
          <img width="100%" :src="scope.row.designUrl + '?x-oss-process=image/resize,w_200'" />
        </template>
      </el-table-column>
      <el-table-column prop="designName" label="IP名称" align="center"></el-table-column>
      <el-table-column width="100" prop="price" label="单价（￥）" align="center"></el-table-column>
      <el-table-column width="100" prop="createTime" label="订单时间" align="center"></el-table-column>
      <el-table-column width="220" prop="orderNo" label="订单号" align="center"></el-table-column>
      <el-table-column width="100" prop="status" label="审核状态" align="center">
        <template slot-scope="scope">
          <el-link v-if="scope.row.checkStatus == 2" @click="open(scope.row)" type="primary">{{ checkStatusObj[scope.row.checkStatus] }}</el-link>
          <span v-else>{{ checkStatusObj[scope.row.checkStatus] }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100" prop="status" label="支付状态" align="center">
        <template slot-scope="scope">
          {{ payStatusObj[scope.row.status] }}
        </template>
      </el-table-column>
      <el-table-column width="100" prop="payType" label="支付方式" align="center">
        <template slot-scope="scope">
          {{ payTypeObj[scope.row.payType] || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="sumPrice" width="140" label="支付金额（￥）" align="center"></el-table-column>
      <el-table-column width="100" prop="tagName" label="防伪码类型" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.countryType == 2 ? '国内' : '国外' }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100" prop="count" label="商品数量" align="center"></el-table-column>
      <el-table-column width="100" prop="brandName" label="品牌及艺术家联名名称" align="center"></el-table-column>
      <el-table-column prop="publishDate" label="产品预计上市时间" align="center"></el-table-column>
      <el-table-column width="140" label="设计图" align="center">
        <template slot-scope="scope">
          <img style="cursor: pointer;" @click="searchBig(scope.row.designImgUrl)" :src="scope.row.designImgUrl + '?x-oss-process=image/resize,w_200'" width="100" />
        </template>
      </el-table-column>
      <el-table-column fixed="right" :width="isBrand ? 400 : 600" label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="searchDetail(scope.row)">查看详情</el-button>
          <el-button v-if="scope.row.checkStatus == 0 && !isBrand" type="primary" size="mini" @click="showAuditModal(scope.row.orderNo)">审核</el-button>
          <el-button type="primary" size="mini" @click="searchLogistics(scope.row)">{{isBrand ? '查看防伪码物流信息' : '查看发货物流'}}</el-button>
          <el-button @click="payConfirmShow(scope.row)" v-if="!isBrand && scope.row.status == 5" :disabled="scope.row.checkStatus != 1" type="primary" size="mini">确认收款</el-button>
          <el-button type="primary" size="mini" @click="fillInLogistics(scope.row)" :disabled="scope.row.status == 5" v-if="!isBrand">更新发货物流</el-button>
          <el-button type="primary" v-if="isBrand && scope.row.status == 5 && scope.row.payType != 4" size="mini" @click="pay(scope.row)">立即支付</el-button>
          <el-button type="primary" v-if="!isBrand && scope.row.paymentUrl" size="mini" @click="searchPayImg(scope.row)">查看凭证</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="site-page">
      <el-pagination background :page-count="totalPage" :current-page="pageNum" @current-change="getList" layout="prev, pager, next, jumper"></el-pagination>
    </div>
    <el-dialog title="更新物流信息" @close="resetForm" :visible.sync="logisticsVisible" width="500px">
      <div class="content">
        <el-form :model="logistics" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="物流名称" prop="expressName">
            <el-input type="text" v-model="logistics.expressName"></el-input>
          </el-form-item>
          <el-form-item label="物流单号" prop="expressNo">
            <el-input type="text" v-model="logistics.expressNo"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logisticsVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmLogistics('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="查看物流信息" :visible.sync="searchVisible" width="500px">
      <div class="content">
        <div>
          <span>物流名称：{{ logistics.expressName }}</span>
        </div>
        <div style="margin-top:20px;">
          <span>物流单号：{{ logistics.expressNo }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="searchVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="支付凭证" :visible.sync="payImgVisible" width="600px">
      <div class="pay-img">
        <img :src="paymentUrl" style="width:100%" alt="" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="payImgVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog @close="diaglogClose" title="确认收款" :visible.sync="voucherVisible" width="500px">
      <el-form :model="addForm" size="small" label-width="100px">
        <el-form-item label="支付类型：">
          <el-radio-group v-model="addForm.payType">
            <el-radio :label="1">支付宝支付</el-radio>
            <el-radio :label="2">微信支付</el-radio>
            <el-radio :label="4">线下支付</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="凭证图片：">
          <el-upload class="upload-demo" :action="ossUrl" :data="addForm.ossDataImg" :limit="1" :on-success="uploaded" :on-change="uploadCg" list-type="picture" :file-list="addForm.authorPicList" accept="image/jpeg,image/png">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">仅支持jpeg或者png，小于20M</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center;">
        <el-button @click="voucherVisible = false">取 消</el-button>
        <el-button type="primary" @click="paymentConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="设计图" :visible.sync="designImgVisible" width="500px">
      <div v-if="designImgVisible">
        <img :src="currentDesignImgUrl" style="width: 100%;" alt="" />
      </div>
    </el-dialog>
    <el-dialog title="查看详情" :visible.sync="detailVisible" width="500px">
      <div class="detail">
        <el-form size="small" label-width="160px">
          <el-form-item label="IP图案：">
            <img v-if="detailVisible" style="cursor: pointer;" @click="searchBig(currentDetail.designUrl)" :src="currentDetail.designUrl + '?x-oss-process=image/resize,w_200'" />
          </el-form-item>
          <el-form-item label="IP名称：">
            {{ currentDetail.designName }}
          </el-form-item>
          <el-form-item label="单价（￥）：">
            {{ currentDetail.price }}
          </el-form-item>
          <el-form-item label="订单时间：">
            {{ currentDetail.createTime }}
          </el-form-item>
          <el-form-item label="订单号：">
            {{ currentDetail.orderNo }}
          </el-form-item>
          <el-form-item label="手机号：">
            {{ currentDetail.phoneNumber }}
          </el-form-item>
          <el-form-item label="地址：">
            {{ currentDetail.address }}
          </el-form-item>
          <el-form-item label="支付状态：">
            {{ payStatusObj[currentDetail.status] }}
          </el-form-item>
          <el-form-item label="支付方式：">
            {{ payTypeObj[currentDetail.payType]}}
          </el-form-item>
          <el-form-item label="支付金额（￥）：">
            {{ currentDetail.sumPrice }}
          </el-form-item>
          <el-form-item label="防伪码类型：">
            {{ currentDetail.countryType == 2 ? '国内' : '国外' }}
          </el-form-item>
          <el-form-item label="商品数量：">
            {{ currentDetail.count }}
          </el-form-item>
          <el-form-item label="品牌及艺术家联名名称：">
            {{ currentDetail.brandName }}
          </el-form-item>
          <el-form-item label="产品预计上市时间：">
            {{ currentDetail.publishDate || '-'  }}
          </el-form-item>
          <el-form-item label="产品类别/名称：">
            {{ currentDetail.ipApply || '-'}}
          </el-form-item>
          <el-form-item label="IP衍生商品销售渠道：">
            {{ currentDetail.ipChannel || '-' }}
          </el-form-item>
          <el-form-item label="设计图：">
            <img v-if="detailVisible" style="cursor: pointer;" @click="searchBig(currentDetail.designImgUrl)" :src="currentDetail.designImgUrl + '?x-oss-process=image/resize,w_200'" width="100" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="detailVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <AuditDialog ref="auditDialog" @fail="fail" @success="success" />
  </div>
</template>

<script>
import API from '../lib/API'
import dayjs from 'dayjs'
import AuditDialog from '../components/common/AuditDialog.vue'
export default {
  name: 'TagManage',
  components: {
    AuditDialog
  },
  data() {
    return {
      ossUrl: '',
      date: '',
      // 是否是品牌商
      isBrand: '',
      tableData: [],
      payTypeObj: {
        1: '支付宝支付',
        2: '微信支付',
        3: '银联支付',
        4: '线下支付'
      },
      payStatusObj: {
        5: '待支付',
        6: '已支付',
        7: '已发货'
      },
      checkStatusObj: {
        0: '待审核',
        1: '审核成功',
        2: '审核失败'
      },
      logistics: {
        expressNo: '',
        expressName: ''
      },
      rules: {
        expressName: [{ required: true, message: '请输入物流名称', trigger: 'blur' }],
        expressNo: [{ required: true, message: '请输入物流单号', trigger: 'blur' }]
      },
      payTypeList: [
        {
          name: '全部',
          value: ''
        },
        {
          name: '支付宝支付',
          value: '1'
        },
        {
          name: '微信支付',
          value: '2'
        },
        {
          name: '线下支付',
          value: '4'
        }
      ],
      statusList: [
        {
          name: '全部',
          value: ''
        },
        {
          name: '待支付',
          value: '5'
        },
        {
          name: '已支付',
          value: '6'
        }
      ],
      payType: '',
      status: '',
      pageNum: 1,
      totalPage: 0,
      phoneNumber: '',
      orderNo: '',
      logisticsVisible: false,
      searchVisible: false,
      currentLogistics: {},
      voucherVisible: false,
      paymentUrl: '',
      payImgVisible: false,
      addForm: {
        authorPic: '',
        ossDataImg: {},
        authorPicList: [],
        payType: 4
      },
      currentDesignImgUrl: '',
      designImgVisible: false,
      detailVisible: false,
      currentDetail: {}
    }
  },
  created() {
    this.isBrand = localStorage.getItem('roleId') === '4'
    this.getList()
  },
  methods: {
    open(row) {
      if (this.isBrand) {
        this.$confirm(row.checkReason, '失败原因', {
          confirmButtonText: '去修改',
          cancelButtonText: '取消'
        }).then(() => {
          this.$router.push({ name: 'OrderConfirm', query: { publishDate: row.publishDate || '', ipApply: row.ipApply || '', ipChannel: row.ipChannel || '', edit: 1, count: row.count, total: row.sumPrice, code: row.code, price: row.price, address: row.address, consignee: row.buyer, telephone: row.phoneNumber, designId: row.designId, orderNo: row.orderNo, orderId: row.id, brandName: row.brandName, designImgUrl: row.designImgUrl, ipImgUrl: row.designUrl + '?x-oss-process=image/resize,w_200' } })
        }).catch((err)=>err)
      } else {
        this.$alert(row.checkReason, '失败原因')
      }
    },

    fail(reason) {
      this.auditMethod(2, reason)
    },
    success() {
      this.auditMethod(1, '')
    },
    showAuditModal(orderNo) {
      this.checkOrderNo = orderNo
      this.$refs.auditDialog.showModal()
    },
    auditMethod(status, reason) {
      new API(this).POST({
        url: '/iporder/check',
        params: {
          orderNo: this.checkOrderNo,
          checkStatus: status,
          checkReason: reason
        },
        cb: res => {
          this.getList(this.pageNum)
        }
      })
    },
    diaglogClose() {
      this.addForm = {
        authorPic: '',
        ossDataImg: {},
        authorPicList: [],
        payType: 4
      }
    },
    searchBig(url) {
      this.designImgVisible = true
      this.currentDesignImgUrl = url
    },
    searchPayImg(row) {
      this.paymentUrl = row.paymentUrl
      this.payImgVisible = true
    },
    payConfirmShow(item) {
      this.currentLogistics = item
      this.getOss()
      this.voucherVisible = true
    },
    pay(row) {
      this.$router.push({ name: 'OrderConfirm', query: { publishDate: row.publishDate, ipApply: row.ipApply, ipChannel: row.ipChannel, count: row.count, total: row.sumPrice, code: row.code, price: row.price, address: row.address, consignee: row.buyer, telephone: row.phoneNumber, designId: row.designId, orderNo: row.orderNo, orderId: row.id, brandName: row.brandName, designImgUrl: row.designImgUrl, ipImgUrl: row.designUrl + '?x-oss-process=image/resize,w_200' } })
    },
    paymentConfirm() {
      if (!this.addForm.authorPic) {
        this.$message.error('请上传凭证！')
        return
      }
      new API(this).POST({
        url: '/iporder/confirmPayOrder',
        params: {
          orderNo: this.currentLogistics.orderNo,
          paymentKey: this.addForm.authorPic,
          payType: this.addForm.payType
        },
        cb: res => {
          if (res === null) {
            this.$notify({
              title: '确认收款成功',
              type: 'success',
              duration: 2000
            })
            this.voucherVisible = false
            this.getList(this.pageNum)
          }
        }
      })
    },
    resetForm() {
      this.$refs['ruleForm'].resetFields()
    },
    confirmLogistics(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.updateLogistics()
        } else {
          return false
        }
      })
    },
    updateLogistics() {
      new API(this).POST({
        url: '/iporder/updateExpress',
        params: {
          expressName: this.logistics.expressName,
          expressNo: this.logistics.expressNo,
          orderNo: this.currentLogistics.orderNo
        },
        cb: res => {
          this.logisticsVisible = false
          this.$notify({
            title: '更新物流信息成功',
            type: 'success',
            duration: 2000
          })
          this.getList(this.pageNum)
        }
      })
    },
    fillInLogistics(item) {
      this.currentLogistics = item
      this.logistics.expressName = item.expressName || ''
      this.logistics.expressNo = item.expressNo || ''
      this.logisticsVisible = true
    },
    searchLogistics(item) {
      if (!item.expressNo) return this.$message.info('暂无物流信息')
      this.currentLogistics = item
      this.logistics.expressName = item.expressName || ''
      this.logistics.expressNo = item.expressNo || ''
      this.searchVisible = true
    },
    searchDetail(item) {
      this.currentDetail = item
      this.detailVisible = true
    },
    uploaded(val) {
      this.addForm.authorPic = this.addForm.ossDataImg.key
    },
    uploadCg(file) {
      this.uploadCgDeal(file, 'ossDataImg')
    },
    uploadCgDeal(file, attr) {
      let ext = file.raw.type
      ext = ext ? '.' + ext.split('/')[1] : ''
      let hasExt = this.ossData.key.indexOf('.')
      if (hasExt === -1) {
        this.addForm[attr]['key'] = this.ossData.key + ext
      } else {
        this.addForm[attr]['key'] = this.ossData.key.slice(0, hasExt)
        this.addForm[attr]['key'] += ext
      }
    },
    getOss() {
      new API(this).POST({
        url: '/oss/getSignature',
        params: {
          count: 1,
          type: 5
        },
        cb: res => {
          this.ossUrl = res.url
          this.ossData = JSON.parse(JSON.stringify(res.signatures[0]))
          this.addForm.ossDataImg = JSON.parse(JSON.stringify(res.signatures[0]))
          this.addForm.ossDataVedio = JSON.parse(JSON.stringify(res.signatures[0]))
        }
      })
    },
    getList(val) {
      if (!isNaN(val)) {
        this.pageNum = val
      } else {
        this.pageNum = 1
      }
      let startTime = ''
      let endTime = ''
      if (this.date) {
        startTime = dayjs(this.date[0]).format('YYYY-MM-DD') + ' 00:00:00'
        endTime = dayjs(this.date[1]).format('YYYY-MM-DD') + ' 23:59:59'
      }
      new API(this).POST({
        url: '/iporder/listWithPage',
        params: {
          count: true,
          pageNum: this.pageNum,
          pageSize: 10,
          phoneNumber: this.phoneNumber,
          status: this.status,
          payType: this.payType,
          orderNo: this.orderNo,
          startTime,
          endTime
        },
        cb: res => {
          let { pages, result } = res

          this.totalPage = pages
          this.tableData = result
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.detail {
  img {
    width: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Authorization.vue